module.exports = __webpack_public_path__ + "static/img/title.9c81a4f5.png";